import {Entity} from "@/app/common/base/entity";
import {Expose} from "class-transformer";

export class NpsFollowUp extends Entity<NpsFollowUp> {
    @Expose()
    question!: string

    @Expose()
    alternatives: string[] = []

    @Expose({ name: 'free_answer' })
    freeAnswer?: string
}
